import { CoordinatesDTO } from './../../shared/dto/common.dto';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { slideDownUp } from 'src/app/shared/animations';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import { NgxCustomModalComponent } from 'ngx-custom-modal';
import { AuthService } from '../../shared/service/auth/auth.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [slideDownUp],
})
export class HomeComponent implements OnInit {
  // @Output() serviceSelected: EventEmitter<string> = new EventEmitter();
  @ViewChild('modal19') modal19!: NgxCustomModalComponent;
  coordinates: CoordinatesDTO = { lat: 0, lng: 0 };
  isMobile: boolean = false;
  isMapVisible: boolean = false;
  isSmallScreen: boolean = true;
  currYear: number = new Date().getFullYear();
  services: string[] = [];
  isDarkMode: boolean = false;
  store: any;
  loading: boolean = true;

  constructor(
    private storeData: Store<any>,
    private router: Router,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private analitycs: AnalitycsService,
    private authService: AuthService,
  ) {
    this.setTranslatedServices();
    this.checkIfMobile();
  }

  ngOnInit() {
    // Verificar si el usuario ya tiene un token y redirigirlo al perfil
    const token = localStorage.getItem('secTkn');
    if (token) {
      console.log('El usuario ya tiene un token, redirigiendo al perfil');
      this.authService.setAuthenticated(true);

      // Mostrar mensaje de bienvenida antes de redirigir
      try {
        // Intentar obtener el nombre del usuario desde localStorage
        const sessionData = localStorage.getItem('session');
        if (sessionData) {
          // El nombre del usuario está disponible en sessionData si se necesita en el futuro
        }

        // Mostrar mensaje personalizado
        this.analitycs.logEvent('redireccion_usuario_autenticado', {
          pantalla: 'home',
          accion: 'redireccion',
          timestamp: new Date().toISOString(),
          plataforma: 'web',
        });

        // Redirigir al perfil
        this.router.navigate(['/profile']);
      } catch (error) {
        console.error('Error al procesar datos de sesión:', error);
        this.router.navigate(['/profile']);
      }
      return;
    }

    // Registrar evento de analítica para usuarios no autenticados
    this.analitycs.logEvent('vista_home', {
      pantalla: 'home',
      accion: 'vista',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });

    this.route.queryParams.subscribe((params) => {
      const lat = Number(params['lat']); // Convertir directamente a número
      const lng = Number(params['lng']);

      if (!isNaN(lat) && !isNaN(lng)) {
        this.coordinates = { lat, lng };
        console.log('Posición obtenida:', this.coordinates);
      } else {
        // console.error('Los parámetros no son números válidos.');
      }
    });

    // this.store.dispatch({ type: 'deviceSize', payload: innerWidth });
    localStorage.setItem('screenWidth', innerWidth.toString());
    console.log(innerWidth, innerHeight);
    this.checkIfMobile();
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
    this.checkScreenSize();
    setTimeout(() => {
      this.loading = false;
    }, 3500);
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth < 768;
    this.isSmallScreen = window.innerWidth <= 770;
  }
  checkScreenSize(): void {
    const width = localStorage.getItem('screenWidth') ?? 0;
    this.isSmallScreen = Number(width) <= 900 ? true : false; // Ajusta el valor según el tamaño deseado
    console.log('isSmallScreen:', this.isSmallScreen);
    // this.cdr.detectChanges();
  }

  toggleMap() {
    this.isMapVisible = !this.isMapVisible; // Alterna entre inicio y mapa
  }

  setTranslatedServices() {
    this.translate
      .get([
        'HOME.SERVICES.OIL_CHANGE',
        'HOME.SERVICES.TIRE_CHECK',
        'HOME.SERVICES.SUSPENSION_INSPECTION',
        'HOME.SERVICES.CARBURETOR_ADJUSTMENT',
        'HOME.SERVICES.BRAKE_CHECK',
        'HOME.SERVICES.TIRE_ROTATION',
        'HOME.SERVICES.FLUID_CHECK',
        'HOME.SERVICES.CLUTCH_ADJUSTMENT',
        'HOME.SERVICES.LIGHT_CHECK',
        'HOME.SERVICES.PREVENTIVE_MAINTENANCE',
        'HOME.SERVICES.PAD_CHANGE',
        'HOME.SERVICES.ELECTRONIC_DIAGNOSTIC',
        'HOME.SERVICES.CAR_WASH_WAX',
        'HOME.SERVICES.BATTERY_REPLACEMENT',
        'HOME.SERVICES.ENGINE_REPAIR',
      ])
      .subscribe((translations) => {
        this.services = [
          translations['HOME.SERVICES.OIL_CHANGE'],
          translations['HOME.SERVICES.TIRE_CHECK'],
          translations['HOME.SERVICES.SUSPENSION_INSPECTION'],
          translations['HOME.SERVICES.CARBURETOR_ADJUSTMENT'],
          translations['HOME.SERVICES.BRAKE_CHECK'],
          translations['HOME.SERVICES.TIRE_ROTATION'],
          translations['HOME.SERVICES.FLUID_CHECK'],
          translations['HOME.SERVICES.CLUTCH_ADJUSTMENT'],
          translations['HOME.SERVICES.LIGHT_CHECK'],
          translations['HOME.SERVICES.PREVENTIVE_MAINTENANCE'],
          translations['HOME.SERVICES.PAD_CHANGE'],
          translations['HOME.SERVICES.ELECTRONIC_DIAGNOSTIC'],
          translations['HOME.SERVICES.CAR_WASH_WAX'],
          translations['HOME.SERVICES.BATTERY_REPLACEMENT'],
          translations['HOME.SERVICES.ENGINE_REPAIR'],
        ];
      });
  }
  goToAssistant() {
    this.router.navigate(['/assistant'], {
      queryParams: this.coordinates.lat === 0 && this.coordinates.lng === 0 ? {} : { lat: this.coordinates.lat, lng: this.coordinates.lng },
    });
  }

  chatAssistant(service: string) {
    if (this.coordinates.lat === 0 && this.coordinates.lng === 0) {
      this.router.navigate(['/assistant'], { queryParams: { service } });
    } else {
      this.router.navigate(['/assistant'], { queryParams: { service, lat: this.coordinates.lat, lng: this.coordinates.lng } });
    }
  }
}
